export default [
  {
    header: 'Control calidad',
    resource: 'Preembarque Re',
    action: 'menu',
  },
  {
    title: 'Despacho',
    icon: 'LayoutIcon',
    children: [
      {
        title: 'Preembarque',
        route: 'preembarquere',
        action: 'menu',
        resource: 'Preembarque Re'
      },
      {
        title: 'Embarque',
        route: 'embarquere',
        action: 'menu',
        resource: 'Embarque Re'
      },
    ],
  },
]
